export default __webpack_public_path__ + "assets/detection_tool.b7722d64.png";